var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoVpBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 464",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1139,167)",
    d: "m0 0h123l17 3 16 6 11 6 11 9 7 7 9 14 5 11 4 14 1 8v12l-3 14-5 12-7 11-10 11-2 1 9 6 9 7 8 10 6 13 3 11 2 14v14l-3 16-5 13-7 12-9 11-9 8-14 8-14 5-15 3-13 1-125-1zm59 54-1 1v64h60l10-3 9-6 5-7 3-12v-8l-2-9-5-9-7-6-8-4-4-1zm0 113-1 1v69l1 1h63l13-2 8-4 6-5 5-9 2-7v-19l-3-10-6-8-5-4-9-3z",
    fill: "#00B454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(907,167)",
    d: "m0 0h115l15 3 16 6 15 8 12 9 13 13 9 14 6 14 3 12 1 7v27l-3 16-5 13-6 11-11 12-10 9-16 10-19 7-17 3h-63v96h-56v-289zm55 54v87h62l11-4 9-6 6-7 4-8 2-9v-17l-3-12-6-10-9-8-11-5-5-1z",
    fill: "#00B454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(614,167)",
    d: "m0 0h62l4 10 20 62 16 50 24 74 7 22 2-3 16-50 18-56 18-57 17-52h63l-3 10-31 93-14 41-29 87-14 41-6 18-1 1h-70l-3-5-26-77-16-47-24-71-16-47-14-41z",
    fill: "#00B454"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(462,167)",
    d: "m0 0h77l5 4 1 2v8l-6 9-10 11-9 11-10 11-9 11-9 10-9 11-9 10-9 11-10 11-9 11-9 10-9 11-10 11-9 11-10 11-9 11-10 11-9 11-11 12-9 11-10 11-7 8-9 9-15 11-16 8-13 3-1-1v-131l8-9 9-11 12-14 9-11 13-15 9-11 9-10 9-11 13-15 11-13 9-9 14-10 12-7 21-8 17-4z",
    fill: "#E5150B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(7,167)",
    d: "m0 0h76l17 3 21 7 16 8 12 8 12 11 8 8 9 11 13 15 12 14 9 11 9 10 9 11 12 14 9 11 12 14 2 3v132l-14-3-16-8-13-10-13-12-9-11-11-12-9-11-11-12-9-11-10-11-9-11-10-11-9-11-10-11-9-11-9-10-9-11-10-11-9-11-9-10-9-11-10-11-9-11-9-10-18-22-2-3v-8l4-5z",
    fill: "#E5150B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1453,244)",
    d: "m0 0h22l17 4 16 7 12 8 10 9 1-21 1-1h51l1 1v206l-52 1-1-1-1-21-9 8-14 9-14 6-16 4-6 1h-16l-21-5-16-7-13-9-10-9-9-11-7-11-7-14-5-16-3-20v-16l3-20 5-16 8-16 7-11 11-12 10-9 13-8 11-5 14-4zm11 49-14 4-11 6-12 11-7 10-5 12-2 9v17l3 12 6 12 8 10 10 8 14 7 7 2 8 1h10l15-3 14-7 10-9 7-8 7-14 3-14v-12l-4-16-7-13-10-11-10-7-12-5-8-2z",
    fill: "#00B454"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1711,243)",
    d: "m0 0h14l16 3 17 8 14 11 9 11 8 16 4 14 2 20v131h-52l-1-126-4-16-6-10-8-7-9-4-5-1h-16l-13 4-9 6-7 8-6 12-3 12-1 122h-51v-207h50l1 1 1 21 10-11 13-9 12-5 12-3z",
    fill: "#00B454"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1814,167)",
    d: "m0 0h52l1 161 12-13 7-8 9-10 9-11 11-12 7-8 8-7 12-6 11-3h48l2 2v5l-9 11-9 10-9 11-10 11-9 11-11 12-9 11-11 12-9 11-10 11-9 11-11 12-5 5-7 3h-9v58l-51 1-1-1z",
    fill: "#00B454"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(388)",
    d: "m0 0h7l4 4 1 4v128l-2 17-6 16-8 13-9 10-9 11-10 11-9 11-9 10-9 11-11 12-9 11-9 10-9 11-10 11h-1v-179l13-15 36-42 9-10 9-11 9-10 9-11 9-10 7-8 5-4z",
    fill: "#E5150B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(150)",
    d: "m0 0h9l10 9 9 11 9 10 9 11 9 10 9 11 9 10 9 11 9 10 9 11 9 10 6 7v180l-5-5-11-12-9-11-11-12-9-11-11-12-9-11-12-13-7-8-12-14-9-11-8-14-4-10-2-8v-145z",
    fill: "#E5150B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1953,250)",
    d: "m0 0h48l2 2v5l-9 11-9 10-9 11-10 11-9 11-11 12-9 11-11 12-9 11-10 11-9 11-11 12-5 5-7 3h-9v-70l13-14 7-8 9-10 9-11 11-12 7-8 8-7 12-6z",
    fill: "#E5150B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1922,358)",
    d: "m0 0 6 3 22 28 13 16 10 13 13 16 11 14 6 8v2h-58l-12-14-11-14-12-14-7-10-4-9v-13l3-6 11-12 6-7z",
    fill: "#00B454"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2013,168)",
    d: "m0 0h14l10 5 7 8 4 9v12l-5 10-4 5-6 4-10 3h-7l-11-4-8-7-5-11v-13l5-10 4-5 9-5zm2 6-9 4-5 6-3 8v8l3 7 5 6 9 4h9l8-3 7-8 2-6v-9l-3-8-8-7-6-2z",
    fill: "#03B456"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2014,181)",
    d: "m0 0 12 1 5 5v8l-3 4h-3l6 9 1 2-6 1-5-5-4-6-1 2-1 8-5 1-1-1v-28zm1 7v5l1 1 7-1 1-4-1-1z",
    fill: "#04B557"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVpBank);
export default __webpack_public_path__ + "static/media/logo_VPBank.e8cb0d4cd3161513566352c38563e413.svg";
export { ForwardRef as ReactComponent };